export default {
  // loans
  appointment: "appointment",
  eligibility: "eligibility",
  incomeVerification: "income-verification",
  offer: "offer",
  needsReview: "needs-review",
  needsReviewStp: "needs-review-stp",
  rejected: "rejected",
  technicalError: "technical-error",
  // insurances
  insurances: "insurances",
  // example-api-call
  exampleApiCall: "example-api-call",
  // example-custom-flow
  exampleCustomFlow: "example-custom-flow",
  // second-onboarding
  secondOnboarding: "second-onboarding",
  // feedback
  loanOfferRejected: "loan-offer-rejected",
  // Stored Value Card
  storedValueCard: "stored-value-card",
  // Corporate
  corporate: "corporate",
  // merhcant-loan
  merchant: "merchant",
  //Excutive referal
  executiveReferal: "executiveReferal",
  stpSales: "stpSales",
  nbcCardForm: "nbcCardForm",
  // Suplementary Card
  supplementaryCard: "supplementary-card",
  //Insurance
  insurance: "insurance",
  insuranceKYC: "insuranceKYC",
  //ReferralProgram
  referralWelcome: "referralWelcome",
  leadCapture: "leadCapture",
  cardReader: "cardReader",
  onboardingDigital: "onboardingDigital",
  //Onboarding Digital
  offerDigital: "offerDigital",
  technicalErrorDigital: "technicalErrorDigital",
  rejectedDigital: "rejectedDigital",
  onboardingDigitalProgress: "onboardingDigitalProgress"
};
